<template>
  <div>
    <div v-if="!hover" class="row">
      <div
        class="text-left"
        v-for="(fields, index) in columns"
        v-bind:style="style"
        :key="index"
      >
        <p
          class="m-0 text-left"
          v-for="(field, index) in fields"
          :key="index"
        >
          {{ field.title }}: <strong> {{ getValue(data[field.key], field.converter) }} </strong>
        </p>
      </div>
    </div>
    <div class="row" v-if="hover">
      <div
        class="text-left"
        v-bind:style="style"
        :key="1"
      >
        <p
          class="m-0 text-left"
          v-for="(field, index) in columns[0]"
          :key="index"
        >
          {{ field.title }}: <strong> {{ getValue(data[field.key], field.converter) }} </strong>
        </p>
      </div>
      <div
        :class="{ 'text-right': true }"
        v-bind:style="{ width: `${100 - width}%` }"
      >
        <slot name="hover"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { converter } from '@/uteis/converters'

export default {
  props: {
    data: { required: true, type: Object },
    hover: { required: true, type: Boolean },
    columns: { required: true, type: Array, default: () => [] }
  },

  computed: {
    width: function () { return 100 / this.columns.length },
    style: function () {
      return {
        width: `${this.width}%`
      }
    }
  },

  methods: {
    getValue (value, type = false) {
      if (type) {
        return converter(type, value).value
      }

      return value
    }
  }
}
</script>
